module.exports = __webpack_public_path__ + "img/db.f542b1d8.png";